import { render, staticRenderFns } from "./v-item.vue?vue&type=template&id=1dabf92a&scoped=true"
import script from "./v-item.vue?vue&type=script&lang=js"
export * from "./v-item.vue?vue&type=script&lang=js"
import style0 from "./v-item.vue?vue&type=style&index=0&id=1dabf92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dabf92a",
  null
  
)

export default component.exports